import ENTITY_FIELD_TYPE from './entityFieldTypes';

const NON_FILTERABLE_COLUMNS = [ENTITY_FIELD_TYPE.MULTI_SELECT, ENTITY_FIELD_TYPE.DROPDOWN, ENTITY_FIELD_TYPE.RELATIONSHIP];

export default NON_FILTERABLE_COLUMNS;
